<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" scrollable :mask="false" draggable class="bind-official-account">
    <div class="content">
      <p>请选择{{title}}绑定方式</p>
      <div @click="leftstyle()" class="check_div" style="float:left">
            <div>
              <img src="../../../assets/image/wxicon.png" class="img"/>
              <p>微信授权</p>
            </div>
            <p>管理员个人微信扫码即可授权</p>
            <p>&nbsp;</p>
            <p class="imgP" v-if="leftchoose">
              <img src="../../../assets/image/choose.png" style="width:40px;height:40px;"/>
            </p>
      </div>
      
      <div @click="rightstyle()" class="check_div">
           <div>
              <img src="@/assets/image/developer.png" class="img"/>
              <p>开发者方式</p>
            </div>
            <p>适合不想直接托管给平台,想直接通过微信</p>
            <p>公众号平台开发者授权模式对接的企业</p>
            <p class="imgP" v-if="rightchoose">
              <img src="../../../assets/image/choose.png" style="width:40px;height:40px;"/>
            </p>

      </div>
      
      
    </div>
    <div slot="footer">
      <Button  type="primary" class="submit_btn"  @click="savebind()">确定</Button>
      <Button type="error" class="cancel_btn"   @click="cancel()">取消</Button>
    </div>
  </Modal>
</template>

<script>
import {publicFunClass} from '@/components/js/PublicFunClass.js'

export default {
  name: 'WechatpublicPop',
  mixins: [publicFunClass],
  props: {
    showWechatpublic: Boolean,
    channelType: String
  },
  data() {
    return {
      model: false,
      title: '微信公众号',
      leftchoose:true,
      rightchoose:false,
    }
  },
  methods: {
    cancel: function () {
      this.$emit('closeWechatpublic', false)
    },
    savebind: function () {
          if(this.rightchoose){
              this.$emit('closeWechatpublic', false,'2')//选开发者方式
          }else{
              this.$emit('closeWechatpublic', false,'1')//选微信授权
          }
    },
    initSearch: function () {
      this.leftchoose=true;
      this.rightchoose=false;
      if(this.channelType == '-8'){
        this.title = "微信公众号";
      }else if(this.channelType == '-9'){
        this.title = "小程序";
      }
    },
    leftstyle: function () {
          this.leftchoose=true;
          this.rightchoose=false;
    },
     rightstyle: function () {
          this.leftchoose=false;
          this.rightchoose=true;
    },


  },
  watch: {
    showWechatpublic: function () {
      this.model = this.showWechatpublic
      if (this.showWechatpublic) {
        this.initSearch()
      }
    }
  }

}
</script>

<style scoped >
  .img{
     width:40px;
     margin-right:10px
  }
  .img > p{
    font-size:18px;
    font-weight:bold;
    margin-left:20px
  }
  .check_div{
    width:46%;
    border:1px solid #eceff3;
    margin:2%;
    padding-bottom:5%;
    display: inline-block;
    text-align:center;
    padding-top: 5%;
  }
  .check_div > div{
    display:flex; 
    align-items: center;
    justify-content: center;
  }
  .check_div > p{
    color:gray;
    margin-top:20px;
    line-height:20px
  }
  .check_div > div > p{
    font-size:20px;
    font-weight:bolder;
  }
  .content{
    margin:0 auto;
  }
  .content > p{
    text-align:center;
    margin:5%;
    font-size:20px;
    font-weight:bolder;
  }
  .imgP{
    position: absolute;
    text-align: right;
    width: 46%;
  }


  
</style>


// WEBPACK FOOTER //
// src/components/systemSetup/DialogueConfigure/WechatpublicPop.vue